const getStoredScreenshotSettingsKey = (widgetId: string): Nullable<string> =>
  widgetId ? `screenshotSettings${widgetId}` : null;

export default getStoredScreenshotSettingsKey;
